<app-header></app-header>
<ion-content scrollbar class="ion-content-padding-top-0">
  <app-breadcrumb></app-breadcrumb>
  <div class="community__container">
    <ion-grid>
      <ion-row>
        <ion-col>
          <app-search-bar
            #searchBar
            classList="community__header-container"
            (searchEvent)="searchbar()"
            [permissionEdit]="permissionAdd"
            buttonAddLabel="{{'ADD_NEW_POST' | translate }}"
            addLink="/app/community/edit-community/{{currentSegment}}/0"
          >
          </app-search-bar>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!communityService.loadingSpinner">
        <ion-col>
          <no-result [collection]="communityService.communities"> </no-result>
          <app-item-community
            *ngFor="let item of communitiesVisible"
            [currentSegment]="currentSegment"
            [community]="item"
            [communityAdmin]="permissionAdmin"
            (refreshRequest)="refreshCommunities()"
          >
            <!-- (keyboardOnScreen)="scrollToInput($event)" -->
          </app-item-community>

          <ion-infinite-scroll (ionInfinite)="loadCommunities($event)">
            <ion-infinite-scroll-content
              loadingSpinner="bubbles"
              loadingText="{{ 'INFINITE_LOADER_INFO_TEXT' | translate }}"
            >
            </ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- Removed button of adding new community item because of problem with tiny editor on iOS  -->
  <!-- <ion-fab
    *ngIf="p.renderMobile && permissionAdd"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button
      routerLink="/app/community/edit-community/{{currentSegment}}/0"
    >
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab> -->
</ion-content>

<div
  *ngIf="communityService.loadingSpinner"
  class="ion-text-center community__loader-container"
>
  <app-loading-sti></app-loading-sti>
</div>
